module.exports = __webpack_public_path__ + "img/bell-selected.e09be3f6.png";